import { bindActionCreators } from 'redux';
import {
  removeFavorite,
  addFavorite,
  getFavoriteVenues,
  getMultipleLists,
  getMultipleListsByVenue,
  getMultipleListVenues,
  getMultipleListVenuesBySlug,
  removeVenueFromList,
  getListBySlugThunk,
  copyListBySlugThunk,
  toggleFavoriteVenue,
  getResyConfigThunk,
  getResyConfigVenueThunk,
  loadResyConfigThunk,
  fetchIpdata,
  getVenueInventoryThunk,
  getVenueReservationsThunk,
  fetchVenuesForBookTonight,
  fetchVenueRecommendations,
  fetchCollections,
  fetchMarketingCollections,
  fetchVenuesForCollection,
  fetchMarketingVenuesForCollection,
  postBookingBookThunk,
  postBookingDetailsThunk,
  postGoogleBookingDetailsThunk,
  removeAuthToken,
  reset,
  resetBookingError,
  resetFavorites,
  resetListById,
  setMultiStepModalMode,
  setMultiStepModalOpenState,
  setMultiStepModalVenueId,
  setMultiStepModalVenueContext,
  setAffId,
  setAuthToken,
  setBookOnBehalfOf,
  setBookOnBehalfOfPayload,
  setCanBook,
  setCountry,
  setDay,
  setItems,
  setNonce,
  setOfferId,
  setPaymentId,
  setPartySize,
  setReplace,
  setReservation,
  setResyToken,
  setServiceCharge,
  setSourceId,
  setVenueId,
  updateMatchMedia,
  updateVenueBlogThunk,
  finalEventsData,
  fetchCityName,
} from '@resy/ui-kitchen';

const getConnectedActions = (dispatch) => bindActionCreators(
  {
    removeFavorite,
    addFavorite,
    getFavoriteVenues,
    getListBySlugThunk,
    copyListBySlugThunk,
    getMultipleLists,
    getMultipleListsByVenue,
    getMultipleListVenues,
    getMultipleListVenuesBySlug,
    removeVenueFromList,
    toggleFavoriteVenue,
    getResyConfigThunk,
    getResyConfigVenueThunk,
    loadResyConfigThunk,
    fetchIpdata,
    getVenueInventoryThunk,
    getVenueReservationsThunk,
    fetchVenuesForBookTonight,
    fetchVenueRecommendations,
    fetchCollections,
    fetchMarketingCollections,
    fetchVenuesForCollection,
    fetchMarketingVenuesForCollection,
    postBookingBookThunk,
    postBookingDetailsThunk,
    postGoogleBookingDetailsThunk,
    removeAuthToken,
    reset,
    resetBookingError,
    resetFavorites,
    resetListById,
    setMultiStepModalMode,
    setMultiStepModalOpenState,
    setMultiStepModalVenueId,
    setMultiStepModalVenueContext,
    setAffId,
    setAuthToken,
    setBookOnBehalfOf,
    setBookOnBehalfOfPayload,
    setCanBook,
    setCountry,
    setDay,
    setItems,
    setNonce,
    setOfferId,
    setPaymentId,
    setPartySize,
    setReplace,
    setReservation,
    setResyToken,
    setServiceCharge,
    setSourceId,
    setVenueId,
    updateMatchMedia,
    updateVenueBlogThunk,
    finalEventsData,
    fetchCityName,
  },
  dispatch
);

export default getConnectedActions;
